module.exports = __webpack_public_path__ + "static/other/gameLibrarian.e9ab57ea.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameLibrarian.json
// module id = 2532
// module chunks = 0